import { Flex } from "@chakra-ui/layout"
import { Skeleton } from "@chakra-ui/skeleton"

const ShowCardSkeleton = ({ listLength }) => (
  <Flex direction="column">
    <Skeleton
      borderRadius="6px"
      marginTop="1.5"
      width={listLength === 1 ? "240px" : ["170px", "200px", "240px"]}
      style={{ aspectRatio: "9/16" }}
    />
  </Flex>
)

export default ShowCardSkeleton
